import jsPDF from "jspdf";

const formatDate = (value) => {
  if (!value) return "-";
  return new Date(value).toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

const formatAmount = (value, currency = "INR") => {
  const amount = Number(value || 0);
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(amount);
};

export const downloadSubscriptionInvoice = (order = {}, options = {}) => {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const platformName = options.platformName || "JOB Portal";
  const title = options.title || "Subscription Invoice";

  const rows = [
    ["Invoice For", title],
    ["Invoice ID", order.id || "-"],
    ["Purchase Date", formatDate(order.purchasedAt || order.createdAt)],
    ["Customer Name", order.user?.name || options.userName || "-"],
    ["Customer Email", order.user?.email || options.userEmail || "-"],
    ["Customer Phone", order.user?.phone || options.userPhone || "-"],
    ["Audience", order.audience === "recruiter" ? "Recruiter" : "Job Seeker"],
    ["Plan", order.plan?.title || order.metadata?.planTitle || "-"],
    ["Plan Duration", order.plan?.durationLabel || order.metadata?.durationLabel || "-"],
    ["Amount", formatAmount(order.amount, order.currency || "INR")],
    ["Payment Status", order.status || "-"],
    ["Payment Gateway", order.provider || "-"],
    ["Gateway Order ID", order.providerOrderId || "-"],
    ["Gateway Payment ID", order.providerPaymentId || "-"],
    ["Start Date", formatDate(order.startsAt)],
    ["Expiry Date", order.isLifetime ? "Forever" : formatDate(order.expiresAt)],
  ];

  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);
  doc.text(platformName, 14, 18);
  doc.setFontSize(14);
  doc.text(title, 14, 28);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  let y = 40;

  rows.forEach(([label, value]) => {
    doc.setFont("helvetica", "bold");
    doc.text(`${label}:`, 14, y);
    doc.setFont("helvetica", "normal");
    const wrapped = doc.splitTextToSize(String(value || "-"), 120);
    doc.text(wrapped, 60, y);
    y += Math.max(7, wrapped.length * 5);
  });

  doc.setFontSize(9);
  doc.text("This is a system-generated subscription invoice.", 14, 285);

  const fileId = String(order.id || "subscription").slice(-10);
  doc.save(`subscription-invoice-${fileId}.pdf`);
};
